var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SButtonCreateOrder',{staticClass:"mb-3",attrs:{"to":"wholesale/new"}}),_c('OrderList',{attrs:{"store":"order.order_wholesale","resource":"/sale/orders/wholesale","orderStatusStore":"order.wholesale_statuses"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }